import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import * as styles from "./FirstVideoCafetera.module.scss";
import video from "../../../videos/cafetera/Cafe_Header.mp4";
import Header from "../../UI/Nav/header";
import { useStaticQuery, graphql } from "gatsby";

const FirstVideoCafetera = ({
  paises,
  categories,
  patternCategory,
  childCategory,
}) => {
  const [videoEnded, setVideoEnded] = useState(false);
  const [ setStyleIndex] = useState(0);

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const [isDropDownOpen, setDropDownOpen] = useState(false);

  const checkMobile = () => window.innerWidth <= 768;

  const blur = isDropDownOpen === true ? "yes" : "no";

  const openAndClose = () => {
    setDropDownOpen(!isDropDownOpen);
  };

  useEffect(() => {
    const updateBodyStyle = () => {
      if (isDropDownOpen && checkMobile()) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    };

    updateBodyStyle();

    window.addEventListener("resize", updateBodyStyle);

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("resize", updateBodyStyle);
    };
  }, [isDropDownOpen]);

  const styleClasses = [
    styles.style1,
    styles.style2,
    styles.style3,
    styles.style4,
  ];

  useEffect(() => {
    if (videoEnded) {
      const intervalId = setInterval(() => {
        setStyleIndex((prevIndex) => (prevIndex + 1) % styleClasses.length);
      }, 2000);

      return () => clearInterval(intervalId);
    }
  }, [videoEnded, styleClasses.length]);

  const handleVideoEnd = () => {
    setVideoEnded(true);
  };

  return (
    <section className={styles.contianer_section}>
      <div className={styles.container_header}>
        <Header
          siteTitle={data.site.siteMetadata.title}
          openAndClose={openAndClose}
          isDropDownOpen={isDropDownOpen}
          paises={paises}
          categories={categories}
          patternCategory={patternCategory}
          childCategory={childCategory}
        />
      </div>
      <motion.video
        autoPlay
        muted
        className={styles.video}
        onEnded={handleVideoEnd}
      >
        <source src={video} type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </motion.video>
    </section>
  );
};

export default FirstVideoCafetera;
